/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2026.5.14",
    versionName: "0.2.0-nightly.2026.5.14",
    versionChannel: "nightly",
    buildDate: "2026-05-14T00:34:01.490Z",
    commitHash: "070debd19af787be6a1862352c2556979a66d181",
};
